import ApiService from "./index";
const resourceList = "/api/Systems/ListGroupAssets";

const GroupAssets = {
    getList() {
        return ApiService.get(resourceList);
    },
};

export default GroupAssets;


// WEBPACK FOOTER //
// ./src/common/api/gassets.js